<section>
<div class="header">
    <h3>
        Session notes from {{booking.instructorName}}
    </h3>
    <h5>Session on {{booking.startDateTime |date: 'MMM d, yyyy @h:mm a'}}</h5>
</div>
<br />
<div class="body">
    <div class="row">
        <div class="col-12 col-sm-12 col-xs-12">
            <div [innerHtml]="safeHtmlNotes" *ngIf="booking.notes"></div>
            <p *ngIf="!booking.notes">Sorry the instructor has not entered notes as of now.</p>
        </div>
    </div>
</div>
<br />
<div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
        <button class="msr-3" mat-raised-button color="primary" (click)="done()">Ok</button>

    </div>
</div>
</section>
